{
	"label": "Trasabilitatea reducerilor de CO\u2082",
	"title": "Trasabilitatea reducerilor de CO\u2082",
	"paragraph": "Reducerile de CO\u2082 pot fi stocate în siguranță pe un blockchain, asigurând transparență și trasabilitate. Prin utilizarea tehnologiei blockchain, fiecare tranzacție asociată reducerilor de CO\u2082 poate fi înregistrată și verificată într-un mod descentralizat și imuabil. Acest lucru permite un sistem fiabil și auditat, în care reducerile de emisii pot fi urmărite și contabilizate cu acuratețe. Astfel, o tranzacție pentru același credit de carbon nu poate fi efectuată de mai multe ori.",
	"close": "Închide"
}
